/**
 * Google Maps URLs (no API key): embed preview + open full map in browser/app.
 * Embed uses legacy `output=embed` - if your region blocks it, switch to Maps Embed API with a key.
 */

export function buildGoogleMapsSearchQuery(parts: {
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  city?: string | null;
  zipCode?: string | null;
  name?: string | null;
}): string | null {
  const line1 = parts.addressLine1?.trim() || "";
  const cityLine = [parts.city?.trim(), parts.zipCode?.trim()].filter(Boolean).join(" ");
  const segments = [line1, cityLine].filter(Boolean);
  if (segments.length === 0) return null;
  return segments.join(", ");
}

/** Opens Google Maps in a new tab / app (recommended for “Open in Google Maps”). */
export function buildGoogleMapsOpenUrl(query: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Iframe src for a simple embedded map (no API key). */
export function buildGoogleMapsEmbedUrl(query: string): string {
  return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=15&output=embed`;
}
